<template>
  <div id="app" class="container">
    <CsHeader/>

    <div class="main" :style="{'top': mainTop}">
      <div class="redBagArea">
        <div class="gra-bg"></div>
        <div class="content" :class="{'builderUI': isBuilder}">
          <h1>
            <span>恭喜你抽中了</span>
          </h1>
          <div class="coupon-list">

            <CouponItem
              v-for="(item, index) in couponList"
              :couponData="item"
              :couponIndex="index"
              :key="index"
              :isBuilder="isBuilder"
              @sendReward:success="getCouponList()"
            />
          </div>

          <div class="interest">
            <p>
              <span>权益已发放至京东账户: </span><span>{{account}}</span>
              <!-- <span class="change-user" clstag="jr|keycount|zy|xg" @click="goLogin">修改</span> -->
            </p>
          </div>

          <JoinSuc
            v-if="isBuilder"
            :dataList="joinRankingList"
            :teamLeaderInfo="teamLeaderInfo"
            :daojishi="daojishi"
            :isComplete="isComplete"
            :isEnd="isEnd"
          />
        </div>
        <template v-if="isBuilder">
          <div class="buttonWrapper builderUI">
            <Sharebtn
              :isComplete="isComplete"
              :isEnd="isEnd"
              :isBuilder="isBuilder"
              @setPopVisible="popupShow($event)"
            />
          </div>
          <img src="./images/bot_suc_bg.png" class="bot-suc-bg" />
        </template>

        <template v-if="!isBuilder">
          <div class="buttonWrapper" v-if="canShareNew">
            <Sharebtn
              :isComplete="isComplete"
              :isEnd="isEnd"
              :isBuilder="isBuilder"
              @setPopVisible="popupShow($event)"
            />
          </div>
          <img v-if="canShareNew" src="./images/bot_fail_bg.png" class="bot-fail-bg"/>

          <img v-if="!canShareNew" src="./images/bot_suc_bg.png" class="bot-suc-bg"/>
        </template>

      </div>

      <img class="bannerwei" v-if="banner.img" :src="banner.img" width="100%" @click="linkTo()">

      <LeaderBoard
        :dataList="luckyRankingList"
        :teamCreateTime="teamLeaderInfo.createTime"
      />
    </div>

    <mt-popup
      v-model="popupVisible"
      popup-transition="popup-fade"
      position="top"
      :modal="true"
      >
      <div class="share-content">
        <img src="./images/share1.png" class="shareImg" alt="点击右上角分享">
      </div>
    </mt-popup>
  </div>
</template>

<script>
import LeaderBoard from "../../components/leaderBoard";
import JoinSuc from "../../components/joinSuc";
import CsHeader from "../../components/CsHeader";
import CouponItem from "../../components/CouponItem";
import Sharebtn from "@/components/ShareBtn";
import { Toast } from 'mint-ui';

import * as api from '@/api'
import * as util from "@/public/util"

let {
  source,
  markId,
  actCode
} = util.parseUrlSearchToObj()

export default {
  data(){
    return{
      teamLeaderInfo:{},//团长、组团信息、激活人数接口
      account:"",//昵称
      luckyRankingList: [],
      joinRankingList: [],
      couponList: [],
      popupVisible: false,
      isBuilder:false,  //角色 是否是团长

      daojishi: undefined, // 倒计时
      timmer: '',

      contents: window.contentData.contents || {},
      share: window.contentData.share || {},
    }
  },
  components: {
    CsHeader,
    LeaderBoard,
    JoinSuc,
    CouponItem,
    Sharebtn
  },

  computed: {
    isComplete () {
      return (Number(this.teamLeaderInfo.differ) === 0)
    },
    isEnd () {
      return !this.isComplete && this.daojishi === 0
    },
    mainTop () {
      let top = parseInt(this.contents.mainTop)
      let toRem = (top - 40) / 16

      return toRem + 'rem'
    },
    canShareNew () {
      return !this.share.disableShare
    },
    banner () {
      return this.contents.banner
    }
  },

  mounted () {
    this.requestData()
    this.listenActive()
  },

  beforeDestroy () {
    this.timmer && clearInterval(this.timmer)
  },

  methods: {
    linkTo () {
      let link = this.banner.link
      if (!link) return

      if($.device.jdjr){
        let defer = jsBridgeV3.onReady();
        defer.then(function (res) {
          this.jsOpenWeb({
              jumpUrl: link,
              jumpType: 8,
              productId: '',
              isclose: false
          })
        })
      }else{
        window.location.href = link;
      }
    },
    // app内webview被唤起的时候触发
    listenActive () {
      let _this = this
      let defer = window.jsBridgeV3.onReady();
      defer.then(function (res) {
        this.jsToGetResp(function(resData){
            resData = (typeof resData == 'object') ? resData : JSON.parse(resData)
            if(resData.type==43){
              // 注意：因为是全部页面监听，所以逻辑代码必须写在返回type值为43 的下边，可能会出现其他问题
              _this.requestData();
              //resData = {"type":43,"showUrl":"https://m.jr.jd.com?sid=xxxxxxx"}
            }
          }, {"type":0})
      })
    },
    popupShow (visible) {
      this.popupVisible = visible
    },
    requestData(){
      this.requestTeamInfo()
      this.getLuckyRankingList()
      this.getJoinList()
      this.getCouponList()
      this.judgeIsBuilder()
    },
    getLuckyRankingList () {
      let params = this.getParams()
      api.getLuckyRankingList(params).then(res => {
        console.log('getLuckyRankingList', res)
        this.luckyRankingList = res
      })
    },
    getJoinList () {
      let params = this.getParams()
      api.getJoinList(params).then(res => {
        // console.log('getJoinList', res)
        this.joinRankingList = res
      })
    },
    getCouponList () {
      let params = this.getParams()

      return api.getCouponList(params).then(couponList => {
        this.couponList = couponList
        this.account = (couponList[0] || {}).pin

        return couponList
      })
    },
    requestTeamInfo(){
      let params = this.getParams()
      api.getTeamLeaderInfo(params).then(teamLeaderInfo => {
        this.teamLeaderInfo = teamLeaderInfo

        this.daojishi = Math.round(Number(teamLeaderInfo.daojishi) / 1000)
        this.timmer && clearInterval(this.timmer)
        this.timmer = setInterval(() => {
          this.daojishi -= 1

          if (this.daojishi <= 0) {
            this.daojishi = 0
            this.timmer && clearInterval(this.timmer)
          }
        }, 1000)
      })
    },
    judgeIsBuilder () {
      let params = this.getParams()

      return api.isBuilder(params).then(resultData => {
        let isBuilder = resultData.success
        this.isBuilder = isBuilder

        return isBuilder
      })
    },
    getParams () {
      let params = {
        reqData: JSON.stringify({
          source,
          ukey: markId,
          actCode,
        })
      }
      return params
    },
    showMsgTost(msg){
      msg && Toast({
        message: msg,
        position: 'top',
        duration: 2000,
        className:"custom-toast"
      })
    },
  },

}
</script>

<style media="screen">
.mint-popup{
  background-color: transparent!important;
}
.v-modal{
  opacity: 0.8!important;
}
.share-content{
  width: 375px;
  top: 10px;
  text-align: center;
  background-color: transparent;
  position: absolute;
  left: -187px;
}
.share-content .shareImg{
  width: 310px;
  height: 94px;
}
</style>

<style  lang="scss" scoped>
.container {

  .main{
    // position: relative;
    // top: -167px;
    position: absolute;
    // top: -10.4375rem;
    // top: 135px;
    width: 100%;
  }
  .redBagArea{
    width: 355px;
    position: relative;
    // top: -161px;
    z-index: 1;
    margin: 0 auto;

    .gra-bg{
      height: calc(100% - 161px) ;
      margin-top: 40px;
      top: 121px;
      position: absolute;
      z-index: -1;
      width: 355px;
      border-radius: 6px;
      background-image: -webkit-linear-gradient( top, #FBD3AD  0%, #FDDFD4   100%),
                  -webkit-linear-gradient( top, #FBD3AD 0%, #FDDFD4 100%);
      position: absolute;
      width: 100%;
    }
    .content{
      position: relative;
      width: 325px;
      margin: 0 auto;
      background: #FFFFFF;
      box-shadow: 0 5px 7px 0 rgba(180,113,65,0.17);
      padding-top: 16px;
      bottom: -40px;
      padding-bottom: 40px;
      .coupon-list{
        padding: 0 20px;
      }
      h1{
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #CB6F46;
        text-align: center;
        margin-bottom: 17px;
        span{
          position: relative;
          display: inline-block;

          &::before{
            display: inline-block;
            content: "";
            width: 33px;
            height: 9px;
            position: absolute;
            background: url(./images/tit_left.png) center no-repeat;
            background-size: cover;
            left: -38px;
            top: 3px;
          }

          &::after{
            display: inline-block;
            content: "";
            width: 33px;
            height: 9px;
            position: absolute;
            background: url(./images/tit_right.png) center no-repeat;
            background-size: cover;
            right: -38px;
            top: 3px;
          }
        }
      }
      .err-txt{
        margin: 40px auto 0;
        display: block;
        width: 250px;
      }
      .interest{
        font-family: PingFang-SC-Regular;
        font-size: 13px;
        color: #E89263;
        letter-spacing: 0;
        text-align: center;
        margin-top: 12px;
        .change-user{
          font-family: PingFang-SC-Medium;
          font-size: 13px;
          color: #FC5846;
          background: none;
          border: none;
          text-decoration: none;
          padding-left: 15px;
        }
      }
    }
    .builderUI.content{
      padding-bottom: 142.5px;
    }
    .sorry{
      height: 43px;
      line-height: 43px;
      font-family: PingFang-SC-Regular;
      font-size: 13px;
      color: #E89263;
      text-align: center;
    }
    .buttonWrapper{
      text-align: center;
      position: absolute;
      z-index: 6;
      bottom: 46.5px;
      left: 0px;
      width: 100%;
    }
    .builderUI.buttonWrapper{
      bottom: 69px;
    }
    .bot-suc-bg{
      width: 355px;
      height: 50px;
      position: relative;
      z-index: 5;
    }
    .bot-fail-bg{
      width: 355px;
      height: 151.5px;
      position: relative;
      z-index: 5;
    }
  }
  .bannerwei{
    margin-top: 30px;
    cursor: pointer;
  }
  .board{
    padding-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/App.vue